var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apple"},[_c('div',{staticClass:"apple-button",on:{"click":_vm.buttonClick}},[_vm._m(0),_c('div',{staticClass:"apple-button__text"},[_vm._v("Sign in with apple")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apple-button__icon"},[_c('img',{attrs:{"src":"/icons/pages/integrations/apple/icon.svg","alt":"apple button-icon"}})])
}]

export { render, staticRenderFns }